<template>
  <div class="wrap">
    <div class="inner">
      <!-- 表单box start -->
      <div class="formBox">
        <form action class="InfoForm">
          <div class="InfoForm_item flex">
            <label for="name" class="commonLabel">
              <span class="red">*</span>
              <i>姓名:</i>
            </label>
            <input
              v-model="addForm.memberName"
              type="text"
              name="userName"
              id="name"
              placeholder="请你输入姓名"
            />
          </div>
          <div class="InfoForm_item InfoForm_Sex flex">
            <label for="DocumentSex" class="commonLabel">
              <span class="red">*</span>
              <i>性别:</i>
            </label>
            <div class="select-box">
              <span>{{sexName}}</span>
              <div class="img-box" @click="isSexShow = true">
                <img src="../assets/image/common/pull.png" />
              </div>
            </div>
          </div>

          <div class="InfoForm_item InfoForm_DocumentNumber flex">
            <label for="DocumentTNumber" class="commonLabel">
			  <span class="red">*</span>
              <i>身份证号码:</i>
            </label>
            <input
              v-model="addForm.memberCardNo"
              type="text"
			  placeholder="请输入身份证号码后6位"
              name="DocumentTNumber"
              id="DocumentTNumber"
			  maxlength="6"/>
          </div>

          <div class="InfoForm_item InfoForm_birthday flex">
            <label for="DocumentTNumber" class="commonLabel">
              <span class="red">*</span>
              <i>出生日期:</i>
            </label>
            <div class="select-box">
              <span>{{addForm.birthDate}}</span>
              <div class="img-box" @click="handleDate()">
                <img src="../assets/image/common/pull.png" />
              </div>
            </div>
          </div>

		  <div v-if="companyBrief=='jxlife'"></div>
          <div class="InfoForm_item InfoForm_DetailedAddress flex" v-else>
            <label for="DetailedAddress" class="commonLabel">
              <span class="red">*</span>
              <i>推荐人工号:</i>
            </label>
            <input
              v-model="addForm.recommender"
              type="text"
              name="DetailedAddress"
              id="DetailedAddress"
            />
          </div>
          <div class="isread">
            <i :class="select == false? '':'chooe'"></i>
            <p>
              <b @click="chooe">我已阅读并同意</b>
              <span @click="treatyClick">《用户协议》</span>
            </p>
          </div>
        </form>
      </div>
      <!-- 表单box end -->

      <!-- 底部按钮div区域 -->
      <div class="foot">
        <div @click="realName" class="btn">下一步</div>
      </div>
    </div>

    <!-- <div id="demo">
      <calendar
        :show.sync="isShowDate"
        :mode="dateMode"
        @change="onChange"
        :defaultDate="addForm.birthDate"
      />
    </div>-->

    <mask-box
      :isShow="isSexShow"
      @handle-close="sexClose"
      :dataList="sexList"
      title="性别"
      @handle-select="sexSelect"
    ></mask-box>
    <div id="date">
      <calendar :show.sync="isShowDate" @change="onChange" :defaultDate="addForm.birthDate" />
      <!-- <inlineCalendar /> -->
    </div>

    <div class="pop-up" v-if="treatyIsShow">
      <div class="pop-mask-box" @click="handleClose"></div>
      <div class="pop-upone">
        <div class="close-icon" @click="handleClose">
          <img src="../assets/image/common/close.png" alt />
        </div>
        <div class="pop-text">
          <div class="pop-inner" @click="Agreement" v-html="argreement.data.agreement">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getApi, postApi } from "../api/index.js";
import MaskBox from "../components/mask-box";
import { get } from "http";
import {AppIdName,TokenName,jxAppId} from '../api/api.js';

export default {
  components: {
    "mask-box": MaskBox
  },
  data() {
    return {
      addRef: false,
      select: false,
      isSexShow: false,
      sexName: "",
      treatyIsShow: false,

      IdList: [],
      sexList: [],
      addForm: {
        birthDate: "",
        memberName: "",
        memberCardNo: "",
        recommender: "",
        sexCode: ""
      },
      isShowDate: false,
      dateMode: "",
      memberName: "",
      memberCardType: "",
      memberCardNo: "",
      recommender: "",
      sexCode: "",
	  companyBrief:sessionStorage.getItem("publicCompanyBrief"),
      argreement:{},
	  appId:'',
    };
  },

  methods: {
    realName() {
      //   console.log(this.addForm.memberCardNo.length);
      if (this.addForm.memberName == "") {
        this.$toast("请输入姓名！");
        return;
      } else if (!this.addForm.sexCode) {
        this.$toast("请选择性别类型！");
        return;
      } else if (!this.addForm.birthDate) {
        this.$toast("请输入出生日期");
        return;
      } else if (this.select == false) {
        this.$toast("请阅读用户协议！");
        return;
      }
	  if (this.addForm.recommender == "") {
		if (!this.companyBrief=='jxlife'){
			this.$toast("推荐人工号必须填写");
	  		return;  
	  	}        
	  }
      this.getCheckEmployee(() => {
        this.toAccount();
      });
    },
    onChange(date) {
      // if (this.dateMode === 'single') {
      this.addForm.birthDate = date.format("YYYY-MM-DD");
      this.isShowDate = false;
      // }
    },

    handleDate() {
      let date = new Date();
      let y = date.getFullYear();
      let m = this.tf(date.getMonth() + 1);
      let d = this.tf(date.getDate());
      let time = y + "-" + m + "-" + d;
      // this.isShowDate = true
      this.$picker.show({
        type: "datePicker",
        date: this.addForm.birthDate || "1990-01-01",
        endTime: time, //截至时间
        startTime: "1880-01-01", //开始时间
        onOk: date => {
          this.addForm.birthDate = date;
        }
      });
    },
    tf(i) {
      return (i < 10 ? "0" : "") + i;
    },
    treatyClick() {
      this.treatyIsShow = true;
    },
    getCheckEmployee(callback) {
		if (this.companyBrief=='jxlife'){
			callback && callback();
		}else{
			getApi({
			  url: "/member/checkEmployee/" + this.addForm.recommender,
			  query: {}
			}).then(res => {
			  if (res.resCode == 0) {
				callback && callback();
			  } else {
				this.$toast(res.resMsg || "员工编号不匹配！");
			  }
			});	
		}         
    },
    toAccount() {
      this.$router.push({
        path: "/bindAcount",
        query: {
          memberName: this.addForm.memberName,
          memberCardNo: this.addForm.memberCardNo,
          recommender: this.addForm.recommender,
          isFrom: this.$route.query.isFrom,
          sexCode: this.addForm.sexCode,
          birthDate: this.addForm.birthDate
        }
      });
    },
    // 协议跳
    addRefs() {
      this.$router.push({
        path: "/protocol",
        query: {}
      });
    },
    handleSelect(item) {
      this.addForm.memberCardType = item.dicName;
      this.memberName = item.dicName;
      this.isokShow = false;
    },

    sexSelect(item) {
      this.sexName = item.dicName;
      this.addForm.sexCode = item.dicCode;
      this.isSexShow = false;
    },
    handleTypeClose() {
      this.isokShow = false;
    },

    chooe() {
      this.select = !this.select;
    },
    getMarit() {
      getApi({ url: "/common/dict/SYS_CARD_TYPE", query: {} })
        .then(res => {
          if (res && res.resCode == 0) {
            this.IdList = res.data;
          }
        })
        .catch(res => {});
    },
    getSexList() {
      // this.isDocumentTypeShow = true;
      getApi({ url: "/common/dict/SYS_SEX", query: {} })
        .then(res => {
          if (res && res.resCode == 0) {
            this.sexList = res.data;
          }
        })
        .catch(res => {
          console.log("获取性别类型失败");
        });
    },
    Agreement() {
      getApi({ url: "/home/agreement", query: {} }).then(res => {
        if (res && res.resCode == 0) {
         this.argreement=res;
        }
      });
    },

    sexClose() {
      this.isSexShow = false;
    },

    handleClose() {
      this.treatyIsShow = false;
    },
    handle() {
      this.isokShow = true;
    }
  },
  created: function() {
	this.appId = localStorage.getItem(AppIdName); 
    this.getMarit(), this.getSexList();
    this.Agreement();
  }
};
</script>
<style lang="less" scoped>
.pop-inner {
  p {
    padding-bottom: 0.2rem;
  }
}
.pop-up {
  width: 100%;
  height: 100%;
  position: fixed;
  box-sizing: border-box;
  z-index: 99;
  left: 0;
  top: 0;
  .close-icon {
    position: absolute;
    right: 0;
    top: 0;
    width: 0.5rem;
    height: 0.5rem;
    padding: 0.1rem;
    cursor: pointer;
    img {
      width: 0.4rem;
      height: 0.4rem;
    }
  }
}
.pop-upone {
  width: 90%;
  height: 80%;
  background-color: #fff;
  padding: 0.6rem 0.4rem 0.4rem;
  // padding: 0 0.74rem;
  box-sizing: border-box;
  font-size: 0.24rem;
  position: absolute;
  top: 50%;
  left: 50%;
  overflow: hidden;
  line-height: 0.5rem;
  border-radius: 0.2rem;
  color: #666666;
  transform: translate(-50%, -50%);
  .pop-text {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
}
.pop-mask-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.35);
}

.wrap {
  width: 100%;
}
.inner {
  //   padding: 0 0.26rem;
  box-sizing: border-box;
  width: 100%;
}

.foot {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 1.22rem;
  text-align: center;
  background: #fff;
  padding-top: 0.16rem;
  box-sizing: border-box;
  .btn {
    display: inline-block;
    width: 4rem;
    height: 0.88rem;
    background: rgb(77, 205, 112);
    line-height: 0.88rem;
    border-radius: 0.3rem;
    color: rgb(255, 255, 255);
    font-size: 0.3rem;
  }
}

.formBox {
  width: 100%;
  .InfoForm {
    width: 100%;
  }

  .InfoForm_address {
    margin-top: 0.16rem;
  }

  .InfoForm_item {
    width: 100%;
    background-color: #fff;
    border-bottom: 0.02rem solid rgb(238, 238, 238);

    input,
    .select-box {
      // padding-left: 2rem;
      text-align: right;
      padding-right: 0.33rem;
      width: 60%;
      font-size: 0.3rem;
      height: 0.9rem;
      border: 0rem transparent solid;
      line-height: 0.9rem;
      .img-box {
        padding-left: 0.16rem;
        display: inline-block;
      }
      img {
        width: 0.28rem;
      }
    }

    .commonLabel {
      padding-left: 0.26rem;
      display: block;
      width: 40%;
      height: 100%;
      // text-align: center;
      line-height: 0.9rem;
      letter-spacing: -0.007rem;
      span {
        color: rgb(255, 0, 0);
        font-size: 0.3rem;
      }
      i {
        width: 0.82rem;
        height: 0.28rem;
        font-size: 0.3rem;
        color: rgb(51, 51, 51);
      }
    }

    input {
      // padding-left: 2rem;
      text-align: right;
      padding-right: 0.33rem;
      width: 60%;
      height: 0.9rem;
      border: 0rem solid transparent;
    }
  }
}
.isread {
  width: 100%;
  padding-left: 0.32rem;
  box-sizing: border-box;
  overflow: hidden;
  padding-top: 0.2rem;
  i {
    display: inline-block;
    width: 0.24rem;
    height: 0.24rem;
    border-radius: 50%;
    border: 0.02rem solid green;
    margin-right: 0.06rem;
    vertical-align: middle;
  }
  p {
    display: inline-block;
    font-size: 0.24rem;
    font-weight: 400;
    color: rgb(153, 153, 153);
    b {
      font-weight: 400;
    }
  }
  span {
    color: rgb(61, 117, 210);
  }
  .chooe {
    background-image: url(../assets/image/start/gou.png);	
    background-size: 100%;    
  }
}
</style>